/** @typedef {import('../routeSchema').RouteNode} RouteNode */

/** @type {RouteNode} */
const publicRoutes = {
  type: "group",
  id: "public",
  guard: "public",
  children: [
    {
      type: "layout",
      id: "auth-layout",
      layout: "auth",
      path: "/",
      children: [
        {
          type: "redirect",
          id: "root-redirect",
          index: true,
          to: "/login",
        },
        {
          type: "route",
          id: "login",
          name: "Login",
          path: "/login",
          component: "Login",
        },
        {
          type: "route",
          id: "register",
          name: "Register",
          path: "/register",
          component: "Signup",
          active: false,
        },
        {
          type: "route",
          id: "forgot-password",
          name: "Forgot Password",
          path: "/forgot-password",
          component: "ForgotPassword",
          // active: false,
        },
        {
          type: "group",
          id: "verify-otp-guard",
          guard: "verifyOtp",
          children: [
            {
              type: "route",
              id: "verify-otp",
              name: "Verify OTP",
              path: "/verify-otp",
              component: "VerifyOTP",
            },
          ],
        },
        {
          type: "group",
          id: "change-password-guard",
          guard: "changePassword",
          children: [
            {
              type: "route",
              id: "change-password",
              name: "Change Password",
              path: "/change-password",
              component: "ChangePassword",
            },
          ],
        },
      ],
    },
  ],
};

export default publicRoutes;
